import { z } from 'zod/v3';
export interface DocMetadata {
  url: string;
  ogUrl: string;
  title: string;
  'og:url': string;
  favicon: string;
  ogImage: string;
  ogTitle: string;
  language: string;
  'og:image': string;
  'og:title': string;
  ogLocale: string;
  scrapeId: string;
  viewport: string;
  generator: string;
  'og:locale': string;
  sourceURL: string;
  screenshot: string;
  statusCode: number;
  description: string;
  htmlFilePath: string;
  'twitter:card': string;
  ogDescription: string;
  'twitter:image': string;
  docusaurus_tag: string;
  'og:description': string;
  markdownFilePath: string;
  'docsearch:version': string;
  docusaurus_locale: string;
  'docsearch:language': string;
  docusaurus_version: string;
  'docsearch:docusaurus_tag': string;
}
export const DocumentChangeTypeSchema = z.enum(['modified', 'added', 'deleted', 'renamed', 'unchanged']);
export type DocumentChangeType = z.infer<typeof DocumentChangeTypeSchema>;

export const DocumentChangeMetadataSchema = z.object({
  frontmatter: z.record(z.string(), z.any()).optional(),
  lastSyncedAt: z.string(),
  lastEditor: z.string(),
  originalSha: z.string(),
});
export type DocumentChangeMetadata = z.infer<typeof DocumentChangeMetadataSchema>;

export const DocumentChangeSchema = z.object({
  id: z.string(),
  path: z.string(),
  workspaceId: z.string(),
  branchId: z.string(),
  content: z.string(),
  originalContent: z.string(),
  baseVersion: z.number(),
  changeType: DocumentChangeTypeSchema,
  timestamp: z.string(),
  isChangedInPlace: z.boolean(),
  metadata: DocumentChangeMetadataSchema,
});

export type DocumentChange = z.infer<typeof DocumentChangeSchema>;
